"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printWarningWithTrace = void 0;
const printWarningWithTrace = message =>
// eslint-disable-next-line no-console -- appropriate here
console.trace(`☢️ WARNING:
${message}`);
exports.printWarningWithTrace = printWarningWithTrace;
//# sourceMappingURL=printWarningWithTrace.js.map